/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import colors from '@sportninja/common/constants/appColors'
import { isCanlan } from '@sportninja/common/utils/customer-name'
import { paragraphSmall } from '../../../../components/css'

/**
 * Container styles for the Selected Division card
 */
export const cardContainer = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`

/**
 * Title styles for the Selected Division label
 */
export const cardTitle = css`
  align-self: flex-start;
`

/**
 * Main card content wrapper styles
 */
export const cardContent = css`
  display: flex;
  flex: 1;
  padding: 16px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid ${colors.NEUTRAL_200};
  background-color: ${colors.NEUTRAL_700};
`

/**
 * Main information row styles
 */
export const infoRow = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  align-self: stretch;
  flex-wrap: wrap;
`

/**
 * Left column with division details
 */
export const detailsColumn = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
`

/**
 * Right column with cost information
 */
export const costColumn = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  /* flex-end, not space-between: the column now holds a trailing fee note that
     must stay attached to the cost above it, rather than being pushed to the
     bottom of a stretched column. */
  justify-content: flex-end;
  align-self: stretch;
`

/**
 * Cost details section styles
 */
export const costDetails = css`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  align-self: flex-end;
`

/**
 * Divider line styles
 */
export const divider = css`
  width: 100%;
  height: 1px;
  background: ${colors.VERY_DARK_GRAYISH_BLUE};
`

/**
 * Bottom action row styles
 */
export const actionRow = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  gap: 8px;

  .mobile-preview & {
    flex-direction: column;
    width: 100%;
  }
`

/**
 * Action button base styles
 */
export const actionButton = css`
  ${paragraphSmall}
  color: ${isCanlan ? colors.NEUTRAL_0 : colors.SECONDARY_300};
  background-color: ${colors.PRIMARY};
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: flex-end;

  .mobile-preview & {
    width: 100%;
    justify-content: center;
  }
`

/**
 * Change division button styles
 * @param isVisible - Whether the button should be visible
 */
export const changeDivisionButton = () => css`
  ${actionButton}
`

/**
 * Promo code button styles
 * @param isActive - Whether the promo code section is active
 * @param isCanlan - Whether this is a Canlan branded instance
 */
export const promoCodeButton = (isActive: boolean, _isCanlan: boolean) => css`
  ${actionButton}
  background-color: ${colors.PRIMARY};
  /* change the opacity of the background color to 0.5 if its not active */
  opacity: ${!isActive ? 1 : 0.5};
`
